// การ์ดแจ้งถอนเครดิต (ลูกค้ากดถอนจากหน้า LIFF) โทนดำทอง
// preview: broadcast-assets/flex-withdraw-request-preview.html
const TH_MONTHS = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];

function formatNumber(n) {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// amount: จำนวนเงินที่แจ้งถอน, when: moment object (เวลาไทย)
function buildWithdrawRequestFlex(amount, when) {
  const value = Number(String(amount).replace(/,/g, "")) || 0;
  const whenText = when.date() + " " + TH_MONTHS[when.month()] + " " + (when.year() + 543) + " " + when.format("HH:mm") + " น.";
  return {
    type: "flex",
    altText: "แจ้งถอนเครดิต " + formatNumber(value) + " บาท",
    contents: {
      type: "bubble",
      size: "kilo",
      styles: { body: { backgroundColor: "#0B0B0B" }, footer: { backgroundColor: "#0B0B0B", separator: false } },
      body: {
        type: "box",
        layout: "vertical",
        paddingAll: "0px",
        backgroundColor: "#0B0B0B",
        contents: [
          {
            type: "box",
            layout: "vertical",
            paddingAll: "16px",
            paddingTop: "14px",
            paddingBottom: "12px",
            background: { type: "linearGradient", angle: "160deg", startColor: "#1A1A1A", centerColor: "#000000", endColor: "#03140A", centerPosition: "60%" },
            contents: [
              {
                type: "box",
                layout: "horizontal",
                contents: [
                  {
                    type: "box",
                    layout: "vertical",
                    flex: 0,
                    backgroundColor: "#F29A1D",
                    cornerRadius: "20px",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    paddingStart: "9px",
                    paddingEnd: "9px",
                    contents: [{ type: "text", text: "💸 ถอนเครดิต", size: "xxs", weight: "bold", color: "#2A1600" }]
                  },
                  { type: "filler" }
                ]
              },
              { type: "text", text: "แจ้งถอนเครดิตแล้ว", weight: "bold", size: "lg", color: "#FFD45A", margin: "sm" },
              { type: "text", text: "ระบบได้รับคำขอของคุณเรียบร้อย", size: "xxs", color: "#9AA39C", margin: "xs", wrap: true },
              {
                type: "image",
                url: "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Flogo2.png?alt=media",
                size: "52px",
                aspectMode: "fit",
                position: "absolute",
                offsetTop: "8px",
                offsetEnd: "12px"
              }
            ]
          },
          {
            type: "box",
            layout: "vertical",
            height: "2px",
            background: { type: "linearGradient", angle: "90deg", startColor: "#0B0B0B", centerColor: "#FFD45A", endColor: "#0B0B0B" },
            contents: [{ type: "filler" }]
          },
          {
            type: "box",
            layout: "vertical",
            paddingAll: "16px",
            paddingTop: "12px",
            paddingBottom: "14px",
            contents: [
              {
                type: "box",
                layout: "vertical",
                paddingAll: "11px",
                cornerRadius: "12px",
                borderWidth: "1.5px",
                borderColor: "#FFD45A",
                backgroundColor: "#161306",
                contents: [
                  { type: "text", text: "จำนวนที่แจ้งถอน", size: "xxs", color: "#B9A86A", align: "center" },
                  { type: "text", text: formatNumber(value), size: "xxl", weight: "bold", color: "#FFD45A", align: "center" },
                  { type: "text", text: "บาท", size: "xs", weight: "bold", color: "#FFE9A8", align: "center" }
                ]
              },
              {
                type: "box",
                layout: "horizontal",
                margin: "md",
                paddingAll: "8px",
                paddingStart: "10px",
                paddingEnd: "10px",
                cornerRadius: "10px",
                backgroundColor: "#141414",
                borderWidth: "1px",
                borderColor: "#262626",
                contents: [
                  { type: "text", text: "📆 วันเวลา", size: "xs", color: "#9A9A9A", flex: 2 },
                  { type: "text", text: whenText, size: "xs", weight: "bold", color: "#F0F0F0", align: "end", flex: 3 }
                ]
              },
              {
                type: "box",
                layout: "horizontal",
                margin: "md",
                paddingAll: "8px",
                paddingStart: "10px",
                paddingEnd: "10px",
                cornerRadius: "10px",
                backgroundColor: "#2A1F00",
                borderWidth: "1px",
                borderColor: "#6B4F00",
                contents: [
                  { type: "text", text: "⏳ รอแอดมินตรวจสอบ", size: "xs", weight: "bold", color: "#FFE9A8", flex: 3 },
                  { type: "text", text: "กำลังดำเนินการ", size: "xxs", color: "#FFD45A", align: "end", flex: 2 }
                ]
              },
              { type: "text", text: "ปกติใช้เวลาไม่เกิน 5 นาทีค่ะ", size: "xxs", color: "#8A8A8A", align: "center", margin: "md" },
              { type: "text", text: "ถ้าเกิน 10 นาที ทักแอดมินได้เลย", size: "xxs", color: "#5F5F5F", align: "center", margin: "xs" }
            ]
          }
        ]
      }
    }
  };
}

module.exports = { buildWithdrawRequestFlex };
